import React, {Component} from 'react';
import {ItemSectionFragment} from "./itemSectionFragment";
import moment from 'moment';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class N_OfficialDocumentSectionFragment extends Component {

  render() {
    const {
      intl:{formatMessage},
      licenseId,
      licenseDeliveryDate,
      idCardNumber,
      birthDate,
      nationality,
      validity
    } = this.props;
    return (
      <React.Fragment>
        <ul style={{paddingInlineStart: 0}}>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.licenseId'})} description={licenseId}/>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.licenseDeliveryDate'})} description={moment(licenseDeliveryDate).format('DD/MM/YYYY')}/>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.idCardNumber'})} description={idCardNumber}/>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.birthDate'})} description={moment(birthDate).format('DD/MM/YYYY')}/>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.nationality'})} description={nationality}/>
          <ItemSectionFragment title={formatMessage({id: 'customer.journey.step.summary.validity'})} description={moment(validity).format('DD/MM/YYYY')}/>
        </ul>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(N_OfficialDocumentSectionFragment)
);




// WEBPACK FOOTER //
// ./src/public/journey1/fragments/sectionFragment/N_OfficialDocumentSectionFragment.js